import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  getRegistrationTimes: [
    'courseId',
    'campus',
    'career',
    'plan',
    'prog',
    'period'
  ],
  getRegistrationTimesRequest: ['courseId'],
  getRegistrationTimesSuccess: ['courseId', 'data'],
  getRegistrationTimesFailure: ['courseId', 'error'],
  getRegistrationTimesClear: null
});

export { Creators, Types };
